import React, { Component }     from 'react';
import PropTypes                from 'prop-types';
import { connect }              from 'react-redux';
import TextField                from 'material-ui/TextField';
import { LinearProgress }       from 'material-ui';
import { Field, reduxForm }     from 'redux-form';
import CloseIcon                from '../CloseIcon';
import { emailValidator }       from '../../utils/validators/emailValidators';
import {
  styles,
  ButtonDiv,
  ButtonsWrapperDiv,
  CONTAINER_HEIGHT,
  ErrorDiv,
  FormWrapperDiv,
  HeaderTitle,
  Title,
  HorLine,
  LeftDiv,
  RightDiv,
}                               from './styles';

import './style.css';
import { getErrorDescription }  from './EmailUpdateFormUtil';
import { ACCENT_COLOR }         from '../../config/colors';

const required = value => (value ? undefined : 'Required');

const validate = (values) => {
  const errors = {};

  if (values.email !== values.confirmEmail) {
    errors.confirmEmail = 'Email Addresses Do Not Match';
  }

  return errors;
};

class EmailUpdateForm extends Component {
    state = {
      mainContainerHeight: CONTAINER_HEIGHT,
    }

    fields = {
      email: null,
      confirmEmail: null,
    }

    secondaryColor = `#${this.props.secondaryColor}`;

    floatingLabelStyle = { color: this.secondaryColor };

    floatingFocusLabelStyle = { color: this.secondaryColor };

    underlineFocusStyle = { borderColor: this.secondaryColor };

    handleInputEnterPress = (e, inputName, touched, error) => {
      if ((e.key === 'Enter' || e.key === '13') && error === undefined) {
        if (inputName === 'email') {
          e.preventDefault();
          this.onInputBlur('email');
          setTimeout(() => {
            this.passwordField.focus();
          }, 250);
        } else if (inputName === 'confirmEmail') {
          this.props.handleSubmit();
        }
      }
    }

    onInputBlur = () => {
      const { isPhone } = this.props;

      if (isPhone) {
        this.setState({
          mainContainerHeight: CONTAINER_HEIGHT,
        });
      }
    }

   renderEmailField = ({
     input, label, meta: { touched, error }, ...custom
   }) => (
     <TextField
       ref={input => (this.emailField = input)}
       type="email"
       onKeyPress={e => this.handleInputEnterPress(e, 'email', touched, error)}
       onBlur={() => this.onInputBlur('email')}
       floatingLabelText={<span style={styles.floatingText}>Email</span>}
       style={styles.textField}
       floatingLabelStyle={this.floatingLabelStyle}
       floatingLabelFocusStyle={this.floatingLabelFocusStyle}
       underlineStyle={styles.underlineStyle}
       underlineFocusStyle={this.underlineFocusStyle}
       errorText={(touched && error ? error : '')}
       {...input}
       {...custom}
     />
   )

   renderConfirmEmailField = ({
     input, label, meta: { touched, error }, ...custom
   }) => (
     <TextField
       ref={input => this.confirmEmailField = input}
       type="email"
       onKeyPress={e => this.handleInputEnterPress(e, 'confirmEmail', touched, error)}
       onBlur={() => this.onInputBlur('confirmEmail')}
       floatingLabelText={<span style={styles.floatingText}>Confirm Email</span>}
       style={styles.textField}
       floatingLabelStyle={this.floatingLabelStyle}
       floatingLabelFocusStyle={this.floatingLabelFocusStyle}
       underlineStyle={styles.underlineStyle}
       underlineFocusStyle={this.underlineFocusStyle}
       errorText={(touched && error ? error : '')}
       {...input}
       {...custom}
     />
   )

   renderProgress = () => (
     <LinearProgress color={ACCENT_COLOR} mode="indeterminate" />
   )

   render() {
     const {
       handleSubmit,
       error,
       onCloseRequest,
       discardError,
       isVerificationSent,
       verificationError,
       isLoading,
     } = this.props;

     const { mainContainerHeight } = this.state;

     if (isVerificationSent) {
       return (
         <React.Fragment>
           <div
             aria-hidden="true"
             role="button"
             tabIndex={0}
             onClick={onCloseRequest}
             style={styles.closeIconWrap}
           >
             <CloseIcon style={styles.closeIcon} />
           </div>
           <FormWrapperDiv style={{ height: '200px' }}>
             <div style={{ width: '100%' }}>
               <HeaderTitle>Email Verification Sent</HeaderTitle>
               <Title>Please check your inbox</Title>
             </div>
           </FormWrapperDiv>
         </React.Fragment>
       );
     }

     if (verificationError) {
       return (
         <React.Fragment>
           <div
             aria-hidden="true"
             role="button"
             tabIndex={0}
             onClick={discardError}
             style={styles.closeIconWrap}
           >
             <CloseIcon style={styles.closeIcon} />
           </div>
           <FormWrapperDiv style={{ height: mainContainerHeight }}>
             <div style={styles.errorFormStyle}>
               <ErrorDiv>{getErrorDescription(verificationError)}</ErrorDiv>
             </div>
           </FormWrapperDiv>
         </React.Fragment>
       );
     }

     return (
       <form name="updateEmailForm" onSubmit={handleSubmit}>
         <div
           aria-hidden="true"
           role="button"
           tabIndex={0}
           onClick={onCloseRequest}
           style={styles.closeIconWrap}
         >
           <CloseIcon style={styles.closeIcon} />
         </div>
         <FormWrapperDiv style={{ height: mainContainerHeight }}>
           <div style={{ width: '100%' }}>
             <HeaderTitle>Update Email</HeaderTitle>
             <HorLine />
           </div>

           <div className="login-input">
             <Field
               name="email"
               validate={[required, emailValidator]}
               component={this.renderEmailField}
             />
           </div>

           <div className="login-input">
             <Field
               name="confirmEmail"
               validate={[required, emailValidator]}
               component={this.renderConfirmEmailField}
             />
           </div>
           {error}
           <div style={{ height: '30px' }} />
           {isLoading && this.renderProgress()}
           {!isLoading && <div style={{ height: '4px' }} />}
           <ButtonsWrapperDiv>
             <LeftDiv><ButtonDiv onClick={onCloseRequest} disabled={isLoading}>Cancel</ButtonDiv></LeftDiv>
             <RightDiv><ButtonDiv onClick={handleSubmit} disabled={isLoading || error} color={this.secondaryColor}>Save</ButtonDiv></RightDiv>
           </ButtonsWrapperDiv>
         </FormWrapperDiv>
       </form>
     );
   }
}

EmailUpdateForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'ChangedPasswordForm',
  validate,
})(EmailUpdateForm);

const mapStateToProps = state => ({
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
});

EmailUpdateForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  onCloseRequest: PropTypes.func.isRequired,
  discardError: PropTypes.func.isRequired,
  isVerificationSent: PropTypes.bool.isRequired,
  verificationError: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  secondaryColor: PropTypes.string.isRequired,
};

EmailUpdateForm.defaultProps = {
  error: '',
  verificationError: '',
};

export default connect(mapStateToProps, null)(EmailUpdateForm);



// WEBPACK FOOTER //
// ./src/components/EmailUpdateFormModal/EmailUpdateForm.jsx